import { render, staticRenderFns } from "./DoExtendedKyc.vue?vue&type=template&id=176dbe49&scoped=true"
import script from "./DoExtendedKyc.vue?vue&type=script&lang=ts"
export * from "./DoExtendedKyc.vue?vue&type=script&lang=ts"
import style0 from "./DoExtendedKyc.vue?vue&type=style&index=0&id=176dbe49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176dbe49",
  null
  
)

export default component.exports